import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=d70b7858&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports